import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Box, Button, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { useRouter } from 'next/router';
import { formatLabel } from './TimeButton.helpers';
import { buttonStyles, checkIconStyles } from './TimeButton.styles';
import { OfficeSearchApiResponse, SlotsSearchResponseV4 } from '@src/lib/__generated/api';
import { EventAppointmentsReturnedValueEventTypeEnum } from '@src/lib/__generated/user-events-api';
import { userEvent } from '@src/services/userEvent';
import { useAppointmentStore, useAppStore, useFormSectionStore } from '@src/store';
import useReschedulingStorePS from '@src/store/modules/patient-services/rescheduling.store';
import { trimTimeZoneOffset } from '@src/utils/trimTimeZoneOffset';
export default function TimeButton({
  id,
  slot,
  location
}: Readonly<{
  id: string;
  slot: SlotsSearchResponseV4;
  location: OfficeSearchApiResponse;
}>) {
  const {
    setAppointmentSlot,
    appointmentSlot,
    setAppointmentFacility
  } = useAppointmentStore(store => store);
  const {
    timeslot: reschedulingTimeslot,
    setTimeslot: setReschedulingTimeslot,
    setSelectedFacility: setReschedulingFacility
  } = useReschedulingStorePS(store => store);
  const isPatientServicesApp = useAppStore(store => store.isPatientServicesApp);
  const {
    completeActiveNode
  } = useFormSectionStore(store => store);
  const router = useRouter();
  const {
    locale
  } = router;
  const selected = isPatientServicesApp ? reschedulingTimeslot?.slotId === slot.slotId : appointmentSlot?.slotId === slot.slotId;
  return <Button id={id} className="time-button" disableTouchRipple sx={buttonStyles(selected)} onClick={() => {
    if (isPatientServicesApp) {
      setReschedulingTimeslot(slot);
      setReschedulingFacility(location);
    } else {
      setAppointmentSlot(slot);
      setAppointmentFacility(location);
      completeActiveNode();
      userEvent({
        event_type: EventAppointmentsReturnedValueEventTypeEnum.AvailableAppointmentsReturned,
        event_data: {
          facility_code: location.facilityCode ?? ''
        }
      });
    }
  }} data-sentry-element="Button" data-sentry-component="TimeButton" data-sentry-source-file="TimeButton.tsx">
			{selected ? <CheckCircleIcon sx={checkIconStyles} data-test-id="icon_selected" /> : null}
			<Typography variant="bodySmallBook" color="secondary.main" data-sentry-element="Typography" data-sentry-source-file="TimeButton.tsx">
				{new Intl.DateTimeFormat(locale, {
        timeStyle: 'short'
      }).format(new Date(trimTimeZoneOffset(slot.time) ?? ''))}
			</Typography>
			<Box sx={visuallyHidden} data-sentry-element="Box" data-sentry-source-file="TimeButton.tsx">{formatLabel({
        location,
        slot
      })}</Box>
		</Button>;
}